import axios from '@/jslib/axios'

export const getAllOptions = data => {
  return axios({
    method: 'post',
    url: '/admin/quote/option',
    data
  })
}

export const getGlobalOptions = params => {
  return axios({
    method: 'get',
    url: '/admin/all/option',
    params
  })
}

export const getCustomerOptions = params => {
  return axios({
    method: 'get',
    url: '/admin/customer/list',
    params
  })
}

export const getCustomerOptionsPhone = params => {
  return axios({
    method: 'get',
    url: '/admin/customer/phone/list',
    params
  })
}

export const getCustomerOptionsEmail = params => {
  return axios({
    method: 'get',
    url: '/admin/customer/email/list',
    params
  })
}
export const getBanks =  params=>{
  return axios({
    method: 'get',
    url: '/admin/card/banks',
    params
  })
}

export const getNationalityOption = params => {
  return axios({
    method: 'get',
    url: '/admin/quote/kyc/nationality',
    params
  })
}